<template>
<div>

	<div>
		<table-list record-name="Maintenance Event"
			:fields="fields"
			:records="mutatedMaintenanceEvents"
			:sortable="true"
			:has-edit="true"
			:has-delete="true"
			delete-endpoint="EquipmentMaintenanceEventType/delete"
			v-on:edit="editEvent"
			v-on:modelChange="fetchEvents">

			<button class="btn btn-primary" type="button" v-on:click="newEvent">
				<i class="fa fa-plus"></i>
				New Event
			</button>

		</table-list>
	</div>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		:working="editModal.working"
		confirm-button-text="Save"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveEvent">

		<field label="Title"
			col-class="col-md-4"
			v-model="editModal.payload.title">
		</field>

		<field label="Category"
			col-class="col-md-4"
			:params="{
				type: 'select',
				options: optionify(categories,'name')
			}"
			v-model="editModal.payload.category_id">
		</field>

		<form-group label="Interval"
			col-class="col-md-4">

			<div class="d-flex">
				<field v-model="editModal.payload.interval"></field>
				<field :params="{
						type: 'select',
						options: [
							{text: 'KM', value: 'km'},
							{text: 'Miles', value: 'mi'},
							{text: 'Hrs', value: 'hrs'},
							{text: 'Days', value: 'days'},
							{text: 'Months', value: 'months'},
						]
					}"
					v-model="editModal.payload.interval_unit">
				</field>
			</div>

		</form-group>

		<field label="Applicable Types"
			col-class="col-md-4"
			:params="{
				type: 'select-multi',
				options: optionify($store.equipmentTypes,'name')
			}"
			v-model="editModal.applicableTypesIds">
		</field>

		<field label="Description"
			col-class="stacked"
			:params="{type: 'textarea'}"
			v-model="editModal.payload.description">
		</field>

		<field label="Warning Interval (days)"
			col-class="col-md-6"
			:params="{type: 'number',min:0, step:1}"
			v-model="editModal.payload.warning_interval_days">
		</field>

		<field label="Danger Interval (days)"
			col-class="col-md-6"
			:params="{type: 'number',min:0, step:1}"
			v-model="editModal.payload.danger_interval_days">
		</field>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

export default {
	name: "EquipmentMaintenanceEvents",
	components: {
		Field,
		FormGroup,
		ModalDialog, 
		TableList
	},
	data() {
		return {
			maintenanceEvents: [],
			categories: [],
			fields: [
				{label: "Title", key: 'title'},
				{label: 'Category',key: 'categoryName'},
				{label: "Interval", key: 'intervalFormatted'},
				{label: "Applicable Types", key: 'applicableTypesConcat'},
				{label: "Warning Intervals", key: 'warnerIntervalsConcat'}
			],
			editModal: {
				visible: false,
				title: "",
				payload: {},
				applicableTypesIds: [],
				working: false
			}
		}
	},
	computed: {
		mutatedMaintenanceEvents() {
			let vm = this
			return this.maintenanceEvents.map(event => {
				event.intervalFormatted = event.interval + " " + event.interval_unit

				let cat = vm.categories.find(cat => cat.id == event.category_id)
				event.categoryName = ""
				if (cat)
					event.categoryName = cat.name

				let applicableTypesIds = event.EquipmentType.map(type => type.id)

				let applicableTypes = event.EquipmentType

				event.applicableTypesConcat = applicableTypes.map(type => type.name).join(", ")

				event.warnerIntervalsConcat = event.warning_interval_days + " days/" + event.danger_interval_days + " days"

				return event
			})
		}
	},
	methods: {
		newEvent() {
			this.editModal.title = "New Maintenance Event"
			this.editModal.visible = true
			this.editModal.payload = {
				title: "",
				interval: "",
				interval_unit: "",
				description: "",
				category_id: null,
				warning_interval_days: 30,
				danger_interval_days: 7
			}
			this.editModal.applicableTypesIds = []
		},
		editEvent(record) {
			this.editModal.title = "Edit Maintenance Event"
			this.editModal.visible = true
			this.editModal.payload = {
				id: record.id,
				title: record.title,
				interval: record.interval,
				interval_unit: record.interval_unit,
				description: record.description,
				category_id: record.category_id,
				warning_interval_days: record.warning_interval_days,
				danger_interval_days: record.danger_interval_days
			}
			this.editModal.applicableTypesIds = []
			this.editModal.applicableTypesIds = record.EquipmentType.map(type => type.id)

		},
		saveEvent() {
			let vm = this

			this.editModal.working = true

			this.editModal.payload.EquipmentType = this.editModal.applicableTypesIds

			this.postData("EquipmentMaintenanceEventType/save",this.editModal.payload,true).then(response => {
				vm.editModal.working = false
				if (response.success) {
					vm.editModal.visible = false
					vm.fetchEvents()
				}
			})
		},
		fetchEvents() {
			let vm = this

			this.getJSON("EquipmentMaintenanceEventType/get",{include: ["EquipmentType"]}).then(response => {
				if (response.success) {
					vm.maintenanceEvents = response.data
				}
			})
		},
		fetchEventTypeCategories() {
			let vm = this

			this.getJSON("EquipmentMaintenanceEventType/categories").then(response => {
				if (response.success) {
					vm.categories = response.data
				}
			})
		}
	},
	created() {

		if (this.$store.equipmentTypes.length == 0)
			this.fetchEquipmentTypes({include: ["EquipmentCategory"]})
		
		this.fetchEvents()
		this.fetchEventTypeCategories()
	}
}	

</script>